import SectionService from "@/services/SectionService";

export const namespaced = true;

export const state = {
    sections: []
};

export const getters = {
    getSections: state => {
        return state.sections;
    }
};

export const mutations = {
    SET_SECTIONS(state, sections) {
        state.sections = sections;
    }
};

export const actions = {
    fetchSectionsByInstitution({ commit }, college) {
        SectionService.fetchSectionLinks(college).then(response => {
            commit("SET_SECTIONS", response.data.data);
        });
    }
};
